export default {
  title: 'Opsæt pakkeleverancer',
  form: {
    title: 'Opret leverance',
    companies: {
      label: 'Virksomheder',
    },
  },
  table: {
    title: 'Leverancehistorik',
    fields: {
      name: 'Virksomhed',
      fulfilled: 'Leveret den',
    },
  },
  buttons: {
    create_fulfillment: 'Opret leverance',
  },
  toasts: {
    failed_to_load_data: 'Data kunne ikke indlæses',
    failed_to_create_fulfillment: 'Leverancen kunne ikke oprettes',
  },
};
